import React from 'react';
import PropTypes from 'prop-types';
import PocTabs from '../../Components/PocTabs/PocTabs';
import { getTabs } from '../../Components/PocTabs/Utils/Context';
import HtmlFromPhp from '../../Core/HtmlFromPhp';
import { setState } from '../../../shared/utils/state';
import { PREPLAY_READY } from '../../../scenes/preplay/constants';
import { getContextIdFromLocation } from '../../Utils/NavigationAdapter';
import { GENERIC_SPORTS_COMPETITIONS } from './constants';

class Outrights extends React.Component {
    async loadCss() {
        await import(/* webpackChunkName: "legacy-preplay-css" */ './styles/generic.scss');
        await import(/* webpackChunkName: "preplay-bet-buttons-css" */ '../../../scenes/preplay/styles/bet-buttons.scss');
    }

    async loadJs() {
        await import(/* webpackChunkName: "legacy-preplay" */ '../../../legacy/shared/prePlay/preplay');
        await import(/* webpackChunkName: "legacy-preplay-selections" */ '../../../scenes/preplay/index');
        await import(/* webpackChunkName: "legacy-status-change" */ '../../../legacy/shared/prePlay/statusChange');
        await import(/* webpackChunkName: "legacy-disable-events" */ '../../../legacy/shared/disable_events');

        setState(PREPLAY_READY, true);
    }

    render () {
        const {
            sportSlug,
            categorySlug,
            tournamentSlug,
        } = this.props.match.params;
        const gtmAttribute = sportSlug + GENERIC_SPORTS_COMPETITIONS;

        const [
            localizedSportSlug = sportSlug,
            localizedCategorySlug = categorySlug,
            localizedTournamentSlug = tournamentSlug,
        ] = this.props.location.state.context.originalUrl;

        const url = `/sportsbook/outrights/${sportSlug}/${categorySlug}/${tournamentSlug}`;

        const tournamentId = getContextIdFromLocation(this.props.location);

        return (
            <div className="outrights">
                <PocTabs
                    tabs={getTabs(sportSlug, localizedSportSlug, {
                        categorySlug: localizedCategorySlug,
                        tournamentSlug: localizedTournamentSlug,
                        tournamentId,
                    })}
                    gtmAttribute={gtmAttribute}
                />
                <HtmlFromPhp key={url} url={url} onComplete={this.loadCss} onDomReady={this.loadJs} />
            </div>
        );
    }
}

Outrights.propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
};

export default Outrights;
